import { all, fork } from "redux-saga/effects";
import AppSaga from "./app/saga";
//layout
import LayoutSaga from "./layouts/saga";
// profile
// import ProfileSaga from "./profile/saga";
//Auth
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import DashboardSaga from "./dashboard/saga";
import CalendarSaga from "./calendar/saga";
import MailSaga from "./mail/saga";
import NotificationSaga from "./notification/saga";

import ReportSaga from "./report/saga";

//corporate
import AddressSaga from "./address/saga";
import ProvinceSaga from "./province/saga";
import CitySaga from "./city/saga";
import DistrictSaga from "./district/saga";
import VillageSaga from "./village/saga";
import BankSaga from "./bank/saga";
import BankDataSaga from "./bankData/saga";
import IdentitySaga from "./identity/saga";
import IdentityTypeSaga from "./identityType/saga";
import MaritalSaga from "./marital/saga";
import MaritalTaxSaga from "./maritalTax/saga";
import ReligionSaga from "./religion/saga";
import EducationSaga from "./education/saga";
import EducationLevelSaga from "./educationLevel/saga";
import FamilyContactSaga from "./familyContact/saga";
import FamilyContactTypeSaga from "./familyContactType/saga";

import ClientSaga from "./client/saga";
import CompanySaga from "./company/saga";
import BrandSaga from "./brand/saga";
import BranchSaga from "./branch/saga";

import FileSaga from "./file/saga";
import FolderSaga from "./folder/saga";

import RoleSaga from "./role/saga";
import RoleListSaga from "./roleList/saga";

//hr
import EmployeeSaga from "./employee/saga";
import EmployeeFaceSaga from "./employeeFace/saga";
import DepartmentSaga from "./department/saga";
import PositionSaga from "./position/saga";
import PermissionCategorySaga from "./permissionCategory/saga";
import EmployeeContractSaga from "./employeeContract/saga";
import EmployeeContractTypeSaga from "./employeeContractType/saga";
import EmployeeWarningSaga from "./employeeWarning/saga";
import PositionChangeSaga from "./positionChange/saga";
import PayrateSaga from "./payrate/saga";
import TerminationSaga from "./termination/saga";
import EmployeeLocationSaga from "./employeeLocation/saga";

import PayrollSaga from "./payroll/saga";
import AttendanceSaga from "./attendance/saga";
import AttEventSaga from "./attEvent/saga";
import AttScheduleSaga from "./attSchedule/saga";
import AttScheduleDetailSaga from "./attScheduleDetail/saga";
import AccSettingSaga from "./accSetting/saga";
import PayrollComponentSaga from "./payrollComponent/saga";
import PayrollComponentDetailSaga from "./payrollComponentDetail/saga";
import payrollSalarySaga from "./payrollSalary/saga";
import WorkGroupSaga from "./workGroup/saga";
import WorkGroupDetailSaga from "./workGroupDetail/saga";
import EmployeeTaxSaga from "./employeeTax/saga";

import PerformanceSaga from "./performance/saga";
import PerformanceAppraisalSaga from "./performanceAppraisal/saga";
import PerformanceAppraisalDetailSaga from "./performanceAppraisalDetail/saga";
import PerformancePredicateSaga from "./performancePredicate/saga";
import PerformanceScoreSaga from "./performanceScore/saga";
import PerformanceScoreDetailSaga from "./performanceScoreDetail/saga";
import EmployeeAssessmentSaga from "./employeeAssessment/saga";
import EmployeeAssessmentDetailSaga from "./employeeAssessmentDetail/saga";

import TaskSaga from "./task/saga";
import TaskDetailSaga from "./taskDetail/saga";
import TaskListSaga from "./taskList/saga";
import TaskListDetailSaga from "./taskListDetail/saga";

import LoanSaga from "./loan/saga";
import LoanTermSaga from "./loanTerm/saga";

import AccTransSaga from "./accTrans/saga";
import AccReleaseTransSaga from "./accReleaseTrans/saga";

import ReimbursementTypeSaga from "./reimbursementType/saga";
import ReimbursementSaga from "./reimbursement/saga";

//Inventory
import ProductSaga from "./product/saga";
import ProductCategorySaga from "./productCategory/saga";
import ProductBlockSaga from "./productBlock/saga";
import ProductOptionSaga from "./productOption/saga";
import ProductOptionDetailSaga from "./productOptionDetail/saga";
import ProductVarianSaga from "./productVarian/saga";
import ProductTagSaga from "./productTag/saga";
import CampaignSaga from "./campaign/saga";
import ProductInventorySaga from "./productInventory/saga";
import ProductInventoryDetailSaga from "./productInventoryDetail/saga";
import ProductTypeSaga from "./productTypes/saga";
import ProductHandoverSaga from "./productHandover/saga";
import ProductComplainSaga from "./productComplain/saga";

import CreditOptionSaga from "./creditOption/saga";

import CreditOptionDetailSaga from "./creditOptionDetail/saga";

//Asset
import AssetSaga from "./asset/saga";
import AssetInspectionSaga from "./assetInspection/saga";
import AssetInspectionCategorySaga from "./assetInspectionCategory/saga";
import AssetTagSaga from "./assetTag/saga";
import AssetCategorySaga from "./assetCategory/saga";
import AssetClassSaga from "./assetClass/saga";
import LegalityAssetSaga from "./legalityAsset/saga";
import ProductInventoryBranchSaga from "./productInventoryBranch/saga";
import UomSaga from "./uom/saga";
import DisposalSaga from "./disposal/saga";
import DepreciationSaga from "./depreciation/saga";
import FollowupListSaga from "./followupList/saga";
import NominatifSaga from "./nominatif/saga";

// import DisposalSaga from "./disposal/saga";

import PaymentMethodSaga from "./paymentMethod/saga";
import PaymentTermSaga from "./paymentTerm/saga";
import ShipmentMethodSaga from "./shipmentMethod/saga";
import ShipmentCarrierSaga from "./shipmentCarrier/saga";

import AccAccountSaga from "./accAccount/saga";
import AccCategorySaga from "./accCategory/saga";
import AccTagSaga from "./accTag/saga";
import AccAccountCloseSaga from "./accAccountClose/saga";
import TransactionTaxSaga from "./transactionTax/saga";

//Purchase
import PurchaseSaga from "./purchase/saga";
import PurchaseDetailSaga from "./purchaseDetail/saga";
import PurchaseHistorySaga from "./purchaseHistory/saga";
import LegalSaga from "./legal/saga";
import LegalMasterSaga from "./legalMaster/saga";
import LegalStatusSaga from "./legalStatus/saga";

//Sales
import SalesSaga from "./sales/saga";
import SalesPublicSaga from "./salesPublic/saga";
import SalesBookSaga from "./salesBook/saga";
import SalesPromoSaga from "./salesPromo/saga";
import SalesDetailSaga from "./salesDetail/saga";
import CampaignDetailSaga from "./campaignDetail/saga";
import SalesHistorySaga from "./salesHistory/saga";
import SalesWarrantySaga from "./salesWarranty/saga";
import SalesPaymentSaga from "./salesPayment/saga";
import MarketingSaga from "./marketing/saga";
import SalesChannelSaga from "./salesChannel/saga";
import SalesTypeSaga from "./salesType/saga";
import SalesTargetSaga from "./salesTarget/saga";
import ApplicantDocumentSaga from "./applicantDocument/saga";
import LegalityDocumentSaga from "./legalityDocument/saga";
import HandoverListSaga from "./handoverList/saga";
import HandoverListEngineeringSaga from "./handoverListEngineering/saga";

//CRM
import ContactSaga from "./contact/saga";
import MarketSaga from "./market/saga";
import DealSaga from "./deal/saga";
import DealTagSaga from "./dealTag/saga";
import DealStatusSaga from "./dealStatus/saga";

//Transfer
import TransferSaga from "./transfer/saga";
import TransferDetailSaga from "./transferDetail/saga";
import TransferHistorySaga from "./transferHistory/saga";

//Customer
import CustomerSaga from "./customer/saga";
import CustomerGroupSaga from "./customerGroup/saga";
import ApplicantSaga from "./applicant/saga";
import BankBranchSaga from "./bankBranch/saga";

//Vendor
import VendorSaga from "./vendor/saga";

//USers
import Users from "./users/saga";
import StorageFileSaga from "./storageFiles/saga";
import StorageFolderSaga from "./storageFolder/saga";
import StorageMoveSaga from "./storageMove/saga";
import StorageRenameSaga from "./storageRename/saga";
import TaskCategorySaga from "./taskCategory/saga";
import ServiceSaga from "./service/saga";
import CampaignPageSaga from "./campaignPage/saga";
import PrintTemplateSaga from "./printTemplate/saga";

import TicketSaga from "./ticket/saga";
import TicketCategorySaga from "./ticketCategory/saga";

//Survey
import SurveySaga from "./survey/saga";
import SurveyScoreSaga from "./surveyScore/saga";
import SurveyTemplateSaga from "./surveyTemplate/saga";
import SurveyTemplateDetailSaga from "./surveyTemplateDetail/saga";

//Agency
import AgentSaga from "./agent/saga";
import AgencySaga from "./agency/saga";

//Konten
import ContentCategorySaga from "./contentCategory/saga";
import ContentSaga from "./content/saga";
import CatalogSaga from "./catalog/saga";

//civilmaterial
import CivilAccountCategorySaga from "./civilAccountCategory/saga";
import CivilAccountSaga from "./civilAccount/saga";
import CivilBudgetSaga from "./civilBudget/saga";
import CivilProgressionSaga from "./civilProgression/saga";
import CivilOpnameSaga from "./civilOpname/saga";
import CivilBudgetDetailSaga from "./civilBudgetDetail/saga";
import CivilBudgetControlSaga from "./civilBudgetControl/saga";
import CivilBudgetControlMaterialSaga from "./civilBudgetControlMaterial/saga";
import CivilBudgetScheduleSaga from "./civilBudgetSchedule/saga";
import CivilBudgetMaterialSaga from "./civilBudgetMaterial/saga";
import CivilContractSaga from "./civilContract/saga";
import BudgetSaga from "./budget/saga";

//perizinana
import LegalSiteplanSaga from "./legalSiteplan/saga";
import LegalBridgeSaga from "./legalBridge/saga";
import LegalPeilSaga from "./legalPeil/saga";
import LegalRumijaSaga from "./legalRumija/saga";
import LegalPermissionSaga from "./legalPermission/saga";
import LegalFractionSaga from "./legalFraction/saga";
import TransactionSaga from "./transaction/saga";
import AdminSaga from "./admin/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AppSaga),
    fork(LayoutSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(NotificationSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(DashboardSaga),
    fork(ClientSaga),
    fork(CompanySaga),
    fork(AddressSaga),
    fork(ProvinceSaga),
    fork(CitySaga),
    fork(DistrictSaga),
    fork(VillageSaga),
    fork(BankSaga),
    fork(BankDataSaga),
    fork(IdentitySaga),
    fork(IdentityTypeSaga),
    fork(BrandSaga),
    fork(BranchSaga),
    fork(MaritalSaga),
    fork(MaritalTaxSaga),
    fork(ReligionSaga),
    fork(EducationSaga),
    fork(EducationLevelSaga),
    fork(FamilyContactSaga),
    fork(FamilyContactTypeSaga),

    fork(CalendarSaga),
    fork(MailSaga),

    fork(ReportSaga),

    fork(FolderSaga),
    fork(FileSaga),

    fork(EmployeeSaga),
    fork(EmployeeFaceSaga),
    fork(DepartmentSaga),
    fork(PositionSaga),
    fork(PermissionCategorySaga),
    fork(EmployeeContractSaga),
    fork(EmployeeContractTypeSaga),
    fork(EmployeeLocationSaga),
    fork(TerminationSaga),
    fork(EmployeeWarningSaga),
    fork(PayrateSaga),
    fork(PositionChangeSaga),
    fork(PayrollSaga),
    fork(AttendanceSaga),
    fork(AttEventSaga),
    fork(AttScheduleSaga),
    fork(AttScheduleDetailSaga),
    fork(AccSettingSaga),
    fork(PayrollComponentSaga),
    fork(PayrollComponentDetailSaga),
    fork(payrollSalarySaga),
    fork(WorkGroupSaga),
    fork(WorkGroupDetailSaga),
    fork(EmployeeTaxSaga),
    fork(LoanSaga),
    fork(LoanTermSaga),

    fork(AccTransSaga),
    fork(AccReleaseTransSaga),
    fork(ReimbursementTypeSaga),
    fork(ReimbursementSaga),

    fork(PerformanceSaga),
    fork(PerformanceScoreSaga),
    fork(PerformanceScoreDetailSaga),
    fork(PerformancePredicateSaga),
    fork(PerformanceAppraisalSaga),
    fork(PerformanceAppraisalDetailSaga),
    fork(EmployeeAssessmentSaga),
    fork(EmployeeAssessmentDetailSaga),

    fork(TaskSaga),
    fork(TaskDetailSaga),
    fork(TaskListSaga),
    fork(TaskListDetailSaga),
    fork(TicketSaga),

    fork(ProductSaga),
    fork(ProductCategorySaga),
    fork(ProductBlockSaga),
    fork(ProductOptionSaga),
    fork(ProductOptionDetailSaga),
    fork(ProductVarianSaga),
    fork(ProductTagSaga),
    fork(CampaignSaga),
    fork(ProductInventorySaga),
    fork(ProductInventoryDetailSaga),
    fork(ProductTypeSaga),
    fork(ProductHandoverSaga),
    fork(ProductComplainSaga),

    fork(CreditOptionSaga),
    fork(CreditOptionDetailSaga),

    fork(AssetSaga),
    fork(AssetInspectionSaga),
    fork(AssetInspectionCategorySaga),
    fork(AssetTagSaga),
    fork(LegalityAssetSaga),
    fork(AssetCategorySaga),
    fork(AssetClassSaga),
    fork(ProductInventoryBranchSaga),
    fork(DisposalSaga),
    fork(DepreciationSaga),
    fork(FollowupListSaga),
    fork(NominatifSaga),

    fork(ContactSaga),
    fork(MarketSaga),
    fork(DealSaga),
    fork(DealTagSaga),
    fork(DealStatusSaga),

    fork(UomSaga),
    fork(PaymentMethodSaga),
    fork(PaymentTermSaga),
    fork(ShipmentMethodSaga),
    fork(ShipmentCarrierSaga),
    fork(TransactionTaxSaga),

    fork(PurchaseSaga),
    fork(PurchaseDetailSaga),
    fork(PurchaseHistorySaga),
    fork(LegalSaga),
    fork(LegalMasterSaga),
    fork(LegalStatusSaga),

    fork(SalesSaga),
    fork(SalesPublicSaga),
    fork(SalesBookSaga),
    fork(SalesPromoSaga),
    fork(SalesDetailSaga),
    fork(MarketingSaga),
    fork(SalesHistorySaga),
    fork(SalesWarrantySaga),
    fork(SalesPaymentSaga),
    fork(CampaignDetailSaga),
    fork(SalesChannelSaga),
    fork(SalesTypeSaga),
    fork(SalesTargetSaga),
    fork(ApplicantDocumentSaga),
    fork(LegalityDocumentSaga),
    fork(HandoverListSaga),
    fork(HandoverListEngineeringSaga),

    fork(TransferSaga),
    fork(TransferDetailSaga),
    fork(TransferHistorySaga),

    fork(CustomerSaga),
    fork(CustomerGroupSaga),
    fork(ApplicantSaga),
    fork(BankBranchSaga),
    fork(VendorSaga),

    fork(AccAccountSaga),
    fork(AccCategorySaga),
    fork(AccTagSaga),
    fork(AccAccountCloseSaga),

    fork(DashboardSaga),

    fork(RoleSaga),
    fork(RoleListSaga),
    fork(Users),
    fork(StorageFileSaga),
    fork(StorageFolderSaga),
    fork(StorageMoveSaga),
    fork(StorageRenameSaga),

    fork(TaskCategorySaga),
    fork(ServiceSaga),
    fork(TicketCategorySaga),
    fork(CampaignPageSaga),
    fork(PrintTemplateSaga),

    fork(SurveySaga),
    fork(SurveyScoreSaga),
    fork(SurveyTemplateSaga),
    fork(SurveyTemplateDetailSaga),

    fork(AgentSaga),
    fork(AgencySaga),

    fork(ContentSaga),
    fork(ContentCategorySaga),
    fork(CatalogSaga),

    fork(CivilAccountCategorySaga),
    fork(CivilAccountSaga),
    fork(CivilProgressionSaga),
    fork(CivilOpnameSaga),
    fork(CivilBudgetSaga),
    fork(CivilBudgetDetailSaga),
    fork(CivilBudgetControlSaga),
    fork(CivilBudgetControlMaterialSaga),
    fork(CivilBudgetScheduleSaga),
    fork(CivilBudgetMaterialSaga),
    fork(CivilContractSaga),
    fork(BudgetSaga),

    fork(LegalSiteplanSaga),
    fork(LegalBridgeSaga),
    fork(LegalPeilSaga),
    fork(LegalRumijaSaga),
    fork(LegalPermissionSaga),
    fork(LegalFractionSaga),
    fork(TransactionSaga),
    fork(AdminSaga),
  ]);
}
